import { all } from 'redux-saga/effects';

import { layoutSaga } from './sagas/layout/saga';

import { getDashboardSaga } from './sagas/dashboard/saga';
import { getPerformanceSnapshotSaga } from './sagas/home/performanceSnapshot/saga';
import { getNewArrivalsSaga } from './sagas/home/newArrivals/saga';
import { getRecommendedCreatorsSaga } from './sagas/home/recommendedCreators/saga';
import { getTopPerformersSaga } from './sagas/home/topPerformers/saga';

import { getMerchantsSaga, deleteMerchantSaga } from './sagas/merchants/saga';
import { createMerchantSaga } from './sagas/merchantsCreate/saga';
import { verifyMerchantSaga } from './sagas/merchantsVerify/saga';
import { getMerchantByIdSaga, editMerchantSaga } from './sagas/merchantsEdit/saga';
import { generateAnalyticsLinksReportSaga } from './sagas/analyticsLinksReport/saga';
import { getAnalyticsCampaignModifiersSaga } from './sagas/analyticsCampaignModifiers/saga';
import { generateAnalyticsUsersReportSaga } from './sagas/analyticsUsersReport/saga';
import {
  getCreatorDetailsCustomSaga,
  getCreatorDetailsPublicSaga,
  getCreatorDetailsSendbirdSaga
} from './sagas/creatorObject/creatorDetails/saga';
import { getChatCreatorDetailsSaga } from './sagas/creatorObject/chatCreatorDetails/saga';
import { getSimilarCreatorsSaga } from './sagas/creatorObject/similarCreators/saga';
import { getCreatorSignalsSaga } from './sagas/creatorObject/creatorSignals/saga';
import { getCreatorMonthlySalesSaga } from './sagas/creatorObject/creatorMonthlySales/saga';
import {
  getCreatorNotesSaga,
  loadMoreCreatorNotesSaga,
  createCreatorNoteSaga,
  updateCreatorNoteSaga,
  removeCreatorNoteSaga
} from './sagas/creatorObject/creatorNotes/saga';
import { getDiscoverSaga, getDiscoverTagsSaga, addDiscoverUsersTagsBulkSaga } from './sagas/discover/saga';
import { getDiscoverBrandsSaga } from './sagas/discoverBrands/saga';
import { getDiscoverCategoriesSaga } from './sagas/discoverCategories/saga';
import { getDiscoverLinkCategoriesSaga } from './sagas/discoverLinkCategories/saga';
import { getDataExportsSaga } from './sagas/dataExports/saga';
import { getMembersSaga, deleteMemberSaga } from './sagas/members/saga';
import { getInvitationsSaga, resendInvitationSaga, deleteInvitationSaga } from './sagas/invitations/saga';
import { inviteMemberSaga } from './sagas/membersInvite/saga';
import { getContactDetailsSaga, changeContactSaga  } from './sagas/organizationContact/saga';
import { getAccountSaga } from './sagas/account/saga';
import { editAccountNameSaga } from './sagas/accountNameEdit/saga';
import { editAccountEmailSaga } from './sagas/accountEmailEdit/saga';
import { editAccountPhoneSaga } from './sagas/accountPhoneEdit/saga';
import { verifyAccountPhoneSaga } from './sagas/accountPhoneVerify/saga';
import { resetAccountPasswordSaga } from './sagas/accountPasswordReset/saga';
import { getFaqSaga, getDefinitionsSaga } from './sagas/help/saga';
import { getNotificationsSaga } from './sagas/notifications/saga';
import { getSwaggerSaga } from './sagas/swagger/saga';
import { getSettingsSaga } from './sagas/settings/saga';
import { acceptInvitationSignUpSaga } from './sagas/acceptInvitationSignUp/saga';
import { updateAvatarSaga, removeAvatarSaga } from './sagas/avatar/saga';
import { createReferralLinkSaga, getReferralLinkSaga } from './sagas/referralsLinks/saga';
import { getReferralConnectionsSaga } from './sagas/referralsConnections/saga';
import { sendReferralInvitationSaga } from './sagas/referralsInvite/saga';
import { getStripeBillingSaga } from './sagas/stripeBilling/saga';
import { getVerifiedDomainsSaga } from './sagas/verifiedDomains/saga';
import { getUnmaskingConnectionSaga } from './sagas/unmasking/connection/saga';
import { getUnmaskingConnectionsSaga } from './sagas/unmasking/connectionsList/saga';
import { getUnmaskingInvitationSaga } from './sagas/unmasking/invitation/saga';
import { getUnmaskingInvitationsSaga } from './sagas/unmasking/invitationsList/saga';
import { withdrawUnmaskingInvitationSaga } from './sagas/unmasking/invitationWithdraw/saga';
import { sendUnmaskingInvitationSaga } from './sagas/unmasking/invitationSend/saga';
import { sendUnmaskingInvitationBulkSaga } from './sagas/unmasking/invitationSendBulk/saga';

import { getRegularusersGroupsSaga } from './sagas/campaigns/groups/list/saga';
import { createRegularusersGroupSaga } from './sagas/campaigns/groups/create/saga';
import { updateRegularusersGroupSaga } from './sagas/campaigns/groups/update/saga';
import { deleteRegularusersGroupSaga } from './sagas/campaigns/groups/delete/saga';
import { getRegularusersGroupSaga } from './sagas/campaigns/groups/get/saga';

import { getAssignmentsSaga } from './sagas/campaigns/assignments/list/saga';
import { getAssignmentSaga } from './sagas/campaigns/assignments/get/saga';
import { createAssignmentSaga } from './sagas/campaigns/assignments/create/saga';
import { checkAssignmentBalanceSaga } from './sagas/campaigns/assignments/checkBalance/saga';
import { updateAssignmentSaga } from './sagas/campaigns/assignments/update/saga';
import { deleteAssignmentSaga } from './sagas/campaigns/assignments/delete/saga';
import { archiveAssignmentSaga } from './sagas/campaigns/assignments/archive/saga';
import { publishAssignmentSaga } from './sagas/campaigns/assignments/publish/saga';
import { uniqueAssignmentNameSaga } from './sagas/campaigns/assignments/uniqueName/saga';
import { addCampaignUsersSaga } from './sagas/campaigns/assignments/addUsers/saga';
import { removeCampaignUsersSaga } from './sagas/campaigns/assignments/removeUsers/saga';
import { getAssignmentSummarySaga } from './sagas/campaigns/assignments/summary/saga';
import { getAssignmentCreatorsPerformanceSaga } from './sagas/campaigns/assignments/creatorsPerformance/saga';

import { tokenAuthSaga } from './sagas/tokenAuth/saga';
import { getSendbirdTokenSaga } from './sagas/sendbird/token/saga';
import { getAiChatTokenSaga, clearAiChatTokenSaga } from './sagas/aiChatToken/saga';
import { getAiPromptSuggestionsSaga } from './sagas/aiPromptSuggestions/saga';
import { createSendbirdGroupSaga } from './sagas/sendbird/groupCreate/saga';

import { getPromotionsSaga } from './sagas/promotions/list/saga';
import { createPromotionSaga } from './sagas/promotions/create/saga';
import { getPromotionSaga, updatePromotionSaga } from './sagas/promotions/update/saga';
import { deletePromotionSaga } from './sagas/promotions/delete/saga';

import { getBaseCommissionRateSaga } from './sagas/baseCommissionRate/saga';
import {
  getNetworkMerchantStatusSaga,
  setNetworkMerchantRateSaga,
  setNetworkMerchantLockingWindowSaga,
  requestNetworkActivationSaga
} from './sagas/networkMerchant/saga';
import { getNetworkOrdersSaga } from './sagas/networkOrders/list/saga';
import { getNetworkOrdersSummarySaga } from './sagas/networkOrders/summary/saga';
import { getNetworkOrderDetailSaga, cancelNetworkOrderSaga } from './sagas/networkOrders/detail/saga';
import {
  getCommissionRulesSaga,
  createCommissionRuleSaga,
  updateCommissionRuleSaga,
  deleteCommissionRuleSaga,
  reorderCommissionRuleSaga
} from './sagas/commissionRules/saga';

import { getMyCreatorsConnectedSaga } from './sagas/myCreators/creators/connectedList/saga';
import {
  getMyCreatorsConnectedScrollSaga,
  refreshMyCreatorsConnectedScrollSaga
} from './sagas/myCreators/creators/connectedListScroll/saga';

import { getMyCreatorsGroupsSaga, pollMyCreatorsGroupsSaga } from './sagas/myCreators/groupsList/saga';

import { createGroupSaga } from './sagas/myCreators/regularGroup/groupCreate/saga';
import { getGroupSaga, updateGroupSaga } from './sagas/myCreators/regularGroup/groupUpdate/saga';
import { deleteGroupSaga } from './sagas/myCreators/regularGroup/groupDelete/saga';
import { addGroupUsersSaga } from './sagas/myCreators/regularGroup/groupUsersAdd/saga';
import { getGroupUsersSaga } from './sagas/myCreators/regularGroup/groupUsersList/saga';
import { removeGroupUsersSaga } from './sagas/myCreators/regularGroup/groupUsersRemove/saga';

import { createSmartGroupSaga } from './sagas/myCreators/smartGroup/groupCreate/saga';
import { getSmartGroupSaga, updateSmartGroupSaga } from './sagas/myCreators/smartGroup/groupUpdate/saga';
import { refreshSmartGroupSaga } from './sagas/myCreators/smartGroup/groupRefresh/saga';
import { deleteSmartGroupSaga } from './sagas/myCreators/smartGroup/groupDelete/saga';

import { sendSendbirdBatchMessageSaga } from './sagas/sendbird/batchMessage/send/saga';
import { getSendbirdBatchMessageInfoSaga } from './sagas/sendbird/batchMessage/info/saga';
import { retrySendbirdBatchMessageSaga } from './sagas/sendbird/batchMessage/retry/saga';
import { getSendbirdBatchMessagesSaga } from './sagas/sendbird/batchMessage/list/saga';

import { getBatchMessageVariablesSaga } from './sagas/sendbird/variables/saga';

import { createBatchMessageTemplateSaga } from './sagas/sendbird/templates/create/saga';
import { getBatchMessageTemplateSaga, updateBatchMessageTemplateSaga } from './sagas/sendbird/templates/update/saga';
import { removeBatchMessageTemplateSaga } from './sagas/sendbird/templates/remove/saga';
import { getBatchMessageTemplatesSaga } from './sagas/sendbird/templates/list/saga';

import { getPerformanceLinksSaga } from './sagas/performance/links/saga';
import { getPerformanceTagsSaga } from './sagas/performance/tags/saga';
import { getPerformanceCreatorsSaga } from './sagas/performance/creators/saga';
import { getPerformanceExportsSaga } from './sagas/performance/exports/saga';

import { createShopifyTokenSaga } from './sagas/shopify/createToken/saga';
import { getShopifyTokensSaga } from './sagas/shopify/getTokens/saga';
import { getShopifyTokenSaga } from './sagas/shopify/getToken/saga';
import { getShopifyStatusSaga } from './sagas/shopify/status/saga';
import { getShopifyProductsSaga } from './sagas/shopify/getProducts/saga';
import { getShopifyCollectionsSaga } from './sagas/shopify/getCollections/saga';
import { getShopifyProductTypesSaga } from './sagas/shopify/getProductTypes/saga';
import { getShopifyCollectionProductsSaga } from './sagas/shopify/getCollectionProducts/saga';
import { getShopifyCollectionVariantCountsSaga } from './sagas/shopify/getCollectionVariantCounts/saga';
import { getShopifyProductVariantsSaga } from './sagas/shopify/getProductVariants/saga';
import { getLookbookLimitsSaga } from './sagas/lookbooks/getLookbookLimits/saga';
import { getShopifyVariantStockSaga } from './sagas/shopify/getVariantStock/saga';

import { getBillingOverviewInfoSaga } from './sagas/billing/overviewInfo/saga';
import { getBillingCreditsBalanceSaga } from './sagas/billing/creditsBalance/saga';
import { getBillingTransactionsSaga } from './sagas/billing/transactions/saga';
import { getBillingInvoicesSaga } from './sagas/billing/invoices/saga';
import { getBillingSubscriptionInfoSaga } from './sagas/billing/subscriptionInfo/saga';
import { billingSubscriptionUpgradeSaga } from './sagas/billing/subscriptionUpgrade/saga';
import { billingSubscriptionPortalSaga } from './sagas/billing/subscriptionPortal/saga';
import { billingSubscriptionModifySaga } from './sagas/billing/subscriptionModify/saga';
import { billingSubscriptionCancelSaga } from './sagas/billing/subscriptionCancel/saga';
import { billingAddCreditsSaga } from './sagas/billing/addCredits/saga';
import { billingAddCreditsPreviewSaga } from './sagas/billing/addCreditsPreview/saga';

import { getCodesSaga } from './sagas/codes/codesList/saga';
import { getCodesProductsScrollSaga } from './sagas/codes/productsListScroll/saga';
import { getCodesCollectionsScrollSaga } from './sagas/codes/collectionsListScroll/saga';
import { createCodeBasicSaga } from './sagas/codes/codeCreateBasic/saga';
import { createCodeBxgySaga } from './sagas/codes/codeCreateBxgy/saga';
import { createCodeShippingSaga } from './sagas/codes/codeCreateShipping/saga';
import { activateCodeSaga } from './sagas/codes/codeActivate/saga';
import { deactivateCodeSaga } from './sagas/codes/codeDeactivate/saga';
import { deleteCodeSaga } from './sagas/codes/codeDelete/saga';
import { assignCodeSaga } from './sagas/codes/codeAssign/saga';
import { getCodeDetailsSaga } from './sagas/codes/codeGetDetails/saga';
import { getCodeRandomSaga } from './sagas/codes/codeGetRandom/saga';
import { getShippingCodeRandomSaga } from './sagas/codes/codeShippingGetRandom/saga';
import { activateCodeBulkSaga } from './sagas/codes/codeActivateBulk/saga';
import { deleteCodeBulkSaga } from './sagas/codes/codeDeleteBulk/saga';
import { deactivateCodeBulkSaga } from './sagas/codes/codeDeactivateBulk/saga';
import { editCodeSaga } from './sagas/codes/codeEdit/saga';

import { getReimbursementsSaga } from './sagas/reimbursements/reimbursementsList/saga';
import { createReimbursementSaga } from './sagas/reimbursements/createReimbursement/saga';
import { checkReimbursementBalanceSaga } from './sagas/reimbursements/checkBalance/saga';
import { endReimbursementsSaga } from './sagas/reimbursements/endReimbursements/saga';

import { getLookbooksSaga } from './sagas/lookbooks/lookbooksList/saga';
import { createLookbookSaga } from './sagas/lookbooks/createLookbook/saga';
import { updateLookbookSaga } from './sagas/lookbooks/updateLookbook/saga';
import { updateLookbookPublishedSaga } from './sagas/lookbooks/updateLookbookPublished/saga';
import { getLookbookSaga } from './sagas/lookbooks/getLookbook/saga';
import { addLookbookUsersSaga } from './sagas/lookbooks/addLookbookUsers/saga';
import { deleteLookbookSaga } from './sagas/lookbooks/deleteLookbook/saga';
import { getLookbookSummarySaga } from './sagas/lookbooks/lookbookSummary/saga';
import { getLookbookUsersSaga } from './sagas/lookbooks/lookbookUsers/saga';

import { getLinkMetaSaga } from './sagas/links/getMeta/saga';
import { uploadLinkPreviewSaga } from './sagas/uploadImage/saga';

import { getLookbookOrderSaga } from './sagas/lookbooks/orders/getLookbookOrder/saga';
import { updateLookbookOrderSaga } from './sagas/lookbooks/orders/updateLookbookOrder/saga';
import { getLookbookOrderItemSaga } from './sagas/lookbooks/orders/getLookbookOrderItem/saga';
import { updateLookbookOrderItemSaga } from './sagas/lookbooks/orders/updateLookbookOrderItem/saga';
import { handoffLookbookOrderShopifySaga } from './sagas/lookbooks/orders/handoffLookbookOrderShopify/saga';
import { markLookbookOrderPlacedSaga } from './sagas/lookbooks/orders/markLookbookOrderPlaced/saga';
import { createLookbookOrderFulfillmentSaga } from './sagas/lookbooks/orders/createLookbookOrderFulfillment/saga';
import { updateLookbookOrderFulfillmentSaga } from './sagas/lookbooks/orders/updateLookbookOrderFulfillment/saga';
import { updateLookbookOrderFulfillmentPackageSaga } from './sagas/lookbooks/orders/updateLookbookOrderFulfillmentPackage/saga';
import { detectTrackingCarrierSaga } from './sagas/lookbooks/tracking/detectCarrier/saga';

export  function* rootSaga() {
  yield all([
    layoutSaga,
    tokenAuthSaga,
    getSendbirdTokenSaga,
    createSendbirdGroupSaga,
    getAiChatTokenSaga,
    clearAiChatTokenSaga,
    getAiPromptSuggestionsSaga,

    getDashboardSaga,
    getPerformanceSnapshotSaga,
    getNewArrivalsSaga,
    getRecommendedCreatorsSaga,
    getTopPerformersSaga,

    getMerchantsSaga,
    deleteMerchantSaga,
    createMerchantSaga,
    verifyMerchantSaga,
    getMerchantByIdSaga,
    editMerchantSaga,
    generateAnalyticsLinksReportSaga,
    getAnalyticsCampaignModifiersSaga,
    generateAnalyticsUsersReportSaga,
    getCreatorDetailsPublicSaga,
    getCreatorDetailsCustomSaga,
    getCreatorDetailsSendbirdSaga,
    getChatCreatorDetailsSaga,
    getSimilarCreatorsSaga,
    getCreatorSignalsSaga,
    getCreatorMonthlySalesSaga,
    getCreatorNotesSaga,
    loadMoreCreatorNotesSaga,
    createCreatorNoteSaga,
    updateCreatorNoteSaga,
    removeCreatorNoteSaga,
    getDiscoverSaga,
    getDiscoverTagsSaga,
    addDiscoverUsersTagsBulkSaga,
    getDiscoverBrandsSaga,
    getDiscoverCategoriesSaga,
    getDiscoverLinkCategoriesSaga,
    getDataExportsSaga,
    getMembersSaga,
    inviteMemberSaga,
    getInvitationsSaga,
    resendInvitationSaga,
    deleteInvitationSaga,
    deleteMemberSaga,
    getContactDetailsSaga,
    changeContactSaga,
    getAccountSaga,
    editAccountNameSaga,
    verifyAccountPhoneSaga,
    editAccountEmailSaga,
    editAccountPhoneSaga,
    resetAccountPasswordSaga,
    getFaqSaga,
    getDefinitionsSaga,
    getNotificationsSaga,
    getSwaggerSaga,
    getSettingsSaga,
    acceptInvitationSignUpSaga,
    updateAvatarSaga,
    removeAvatarSaga,
    getReferralLinkSaga,
    createReferralLinkSaga,
    getReferralConnectionsSaga,
    sendReferralInvitationSaga,
    getStripeBillingSaga,
    getVerifiedDomainsSaga,
    getUnmaskingConnectionSaga,
    getUnmaskingConnectionsSaga,
    getUnmaskingInvitationSaga,
    getUnmaskingInvitationsSaga,
    withdrawUnmaskingInvitationSaga,
    sendUnmaskingInvitationSaga,
    sendUnmaskingInvitationBulkSaga,

    getRegularusersGroupsSaga,

    createRegularusersGroupSaga,
    updateRegularusersGroupSaga,
    deleteRegularusersGroupSaga,
    getRegularusersGroupSaga,

    getAssignmentsSaga,
    getAssignmentSaga,
    createAssignmentSaga,
    checkAssignmentBalanceSaga,
    updateAssignmentSaga,
    deleteAssignmentSaga,
    archiveAssignmentSaga,
    publishAssignmentSaga,
    uniqueAssignmentNameSaga,
    getBaseCommissionRateSaga,
    getNetworkMerchantStatusSaga,
    setNetworkMerchantRateSaga,
    setNetworkMerchantLockingWindowSaga,
    requestNetworkActivationSaga,
    getNetworkOrdersSaga,
    getNetworkOrdersSummarySaga,
    getNetworkOrderDetailSaga,
    cancelNetworkOrderSaga,
    getCommissionRulesSaga,
    createCommissionRuleSaga,
    updateCommissionRuleSaga,
    deleteCommissionRuleSaga,
    reorderCommissionRuleSaga,
    addCampaignUsersSaga,
    removeCampaignUsersSaga,
    getAssignmentSummarySaga,
    getAssignmentCreatorsPerformanceSaga,

    getPromotionsSaga,
    createPromotionSaga,
    getPromotionSaga,
    updatePromotionSaga,
    deletePromotionSaga,

    getMyCreatorsConnectedSaga,
    getMyCreatorsConnectedScrollSaga,
    refreshMyCreatorsConnectedScrollSaga,

    getMyCreatorsGroupsSaga,
    pollMyCreatorsGroupsSaga,

    createGroupSaga,
    getGroupSaga,
    updateGroupSaga,
    deleteGroupSaga,
    addGroupUsersSaga,
    removeGroupUsersSaga,
    getGroupUsersSaga,

    createSmartGroupSaga,
    getSmartGroupSaga,
    updateSmartGroupSaga,
    refreshSmartGroupSaga,
    deleteSmartGroupSaga,

    sendSendbirdBatchMessageSaga,
    getSendbirdBatchMessageInfoSaga,
    retrySendbirdBatchMessageSaga,
    getSendbirdBatchMessagesSaga,

    getBatchMessageVariablesSaga,

    createBatchMessageTemplateSaga,
    getBatchMessageTemplateSaga,
    updateBatchMessageTemplateSaga,
    removeBatchMessageTemplateSaga,
    getBatchMessageTemplatesSaga,

    getPerformanceTagsSaga,
    getPerformanceLinksSaga,
    getPerformanceCreatorsSaga,
    getPerformanceExportsSaga,

    createShopifyTokenSaga,
    getShopifyTokensSaga,
    getShopifyTokenSaga,
    getShopifyStatusSaga,
    getShopifyProductsSaga,
    getShopifyCollectionsSaga,
    getShopifyProductTypesSaga,
    getShopifyCollectionProductsSaga,
    getShopifyCollectionVariantCountsSaga,
    getShopifyProductVariantsSaga,
    getLookbookLimitsSaga,
    getShopifyVariantStockSaga,

    getBillingOverviewInfoSaga,
    getBillingCreditsBalanceSaga,
    billingAddCreditsSaga,
    billingAddCreditsPreviewSaga,
    getBillingTransactionsSaga,
    getBillingInvoicesSaga,
    getBillingSubscriptionInfoSaga,
    billingSubscriptionUpgradeSaga,
    billingSubscriptionPortalSaga,
    billingSubscriptionModifySaga,
    billingSubscriptionCancelSaga,

    getCodesSaga,
    getCodesProductsScrollSaga,
    getCodesCollectionsScrollSaga,
    createCodeBasicSaga,
    createCodeBxgySaga,
    createCodeShippingSaga,
    getCodeRandomSaga,
    getShippingCodeRandomSaga,
    getCodeDetailsSaga,
    deleteCodeSaga,
    deleteCodeBulkSaga,
    deactivateCodeSaga,
    deactivateCodeBulkSaga,
    activateCodeSaga,
    activateCodeBulkSaga,
    assignCodeSaga,
    editCodeSaga,

    getReimbursementsSaga,
    createReimbursementSaga,
    checkReimbursementBalanceSaga,
    endReimbursementsSaga,

    getLookbooksSaga,
    createLookbookSaga,
    updateLookbookSaga,
    updateLookbookPublishedSaga,
    getLookbookSaga,
    deleteLookbookSaga,
    addLookbookUsersSaga,
    getLookbookUsersSaga,
    getLookbookSummarySaga,

    getLookbookOrderSaga,
    updateLookbookOrderSaga,
    getLookbookOrderItemSaga,
    updateLookbookOrderItemSaga,
    handoffLookbookOrderShopifySaga,
    markLookbookOrderPlacedSaga,
    createLookbookOrderFulfillmentSaga,
    updateLookbookOrderFulfillmentSaga,
    updateLookbookOrderFulfillmentPackageSaga,
    detectTrackingCarrierSaga,

    getLinkMetaSaga,
    uploadLinkPreviewSaga
  ]);
}
